// extracted by mini-css-extract-plugin
module.exports = {"row":"history_row__1HEt6","container":"history_container__2h61D"};